function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import Common from '../components/includes/Common';
import { Container, Col, Row, ControlLabel } from 'react-bootstrap';
import { message, Skeleton, Descriptions } from 'antd';
import ChangePassword from "../components/forms/ChangePassword";
import { PersonCircle } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var AccountConfig = function AccountConfig() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    user = _useState2[0],
    setUser = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + 'getuser/' + Common.currentUser.id + '/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setUser(response.data.user);
      } else {
        message.error({
          content: response.data.message,
          duration: 3
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenuee',
        duration: 3
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 5,
          children: /*#__PURE__*/_jsxs("div", {
            className: "cool-radius",
            style: {
              background: '#FCB31C'
            },
            children: [user != null && /*#__PURE__*/_jsx(Container, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 4,
                  md: 4,
                  sm: 3,
                  xs: 3,
                  children: /*#__PURE__*/_jsx(PersonCircle, {
                    size: 55
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 8,
                  md: 8,
                  sm: 9,
                  xs: 9,
                  children: /*#__PURE__*/_jsxs(Descriptions, {
                    title: "Info Utilisateur",
                    column: 1,
                    children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                      label: "Login",
                      children: user.mobile.slice(3)
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: "P\xE9nom",
                      children: user.firstname
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: "Nom",
                      children: user.lastname
                    })]
                  })
                })]
              })
            }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 7,
          children: /*#__PURE__*/_jsx("div", {
            className: "white-bg",
            children: /*#__PURE__*/_jsx(ChangePassword, {
              user: user
            })
          })
        })]
      })
    })
  });
};
export default AccountConfig;